export const defaultFontColor = "#000000";

export const defaultBackgroundColor = "#ffffff";
